module.exports = __webpack_public_path__ + "img/chips50.a39c85d8.png";